// Override some settings from jquery.unobtrusive
$(function () {

	$("form").each(function () {
		var $form = $(this);
		var validator = $form.data("validator");
		if (!validator){
			return;
		}

		var settings = validator.settings;
		settings.highlight = function (element) { //also passed, not used - errorClass, validClass
			$(element).attr("data-error-highlight", "y");
			var $field = $(element).closest("li");
			$field.addClass("field-error");
		};

		settings.unhighlight = function (element) { //also passed, not used - errorClass, validClass
			$(element).attr("data-error-highlight", "n");
			var $field = $(element).closest("li");
			if ($field.find("[data-error-highlight=y]").length === 0) {
				$field.removeClass("field-error");
			}
		};

		// Override standard keyup/focus events to prevent annoying behaviour on mobiles
		settings.onkeyup = false;
		settings.onfocusout = false;

		// Trim email before running the validation on it
		if (settings.rules) {
			$.each(settings.rules, function(index, element) {
				if (element && element.email === true) {
					element.required = {
						depends: function () {
							$(this).val($.trim($(this).val()));
							return true;
						}
					}
				}
			});
		}

		// Hide custom error message when form validates - as two error messages looks clumsy
		$form.on("submit", function(event) {
			if (event.result) {
				//validate suceeded
				return;
			}
			if (!$form.valid()) {
				$(".custom-error-message").hide();
			}
		});

		function isCreditCardLike(value) {
			//please keep me updated along with fastpay, fastbill, loggedinweb, merchant portal  and webgiving
			var creditCardRegex = /([2-6](\d[ \-]*){11,18})/i;
			return creditCardRegex.test(value);
		}

		function addPanHandlingValidationRule() {
			$.validator.addMethod('panhandling', function (value) {
				return !isCreditCardLike(value);
			});

			var unobtrusive = $.validator.unobtrusive;
			unobtrusive.adapters.add('panhandling', function (options) {
				options.rules['panhandling'] = true;
				if (options.message) {
					options.messages['panhandling'] = options.message;
				}
			});
		};

		function attachElementValidation(element) {
			//that is a replicata of $.validator.unobtrusive.parseElement
			//https://github.com/aspnet/jquery-validation-unobtrusive/blob/master/jquery.validate.unobtrusive.js#L163

			//parseElement does not add the element to the validator if the validator has been created
			//here we're using the same logic to update validator settings

			var $element = $(element);
			var form = $element.closest('form')[0];
			var validator = $(form).data('validator');

			if (validator) {
				// ReSharper disable once InconsistentNaming
				var rules = { '__dummy__': true };
				var messages = {};
				var unobtrusive = $.validator.unobtrusive;

				validator.settings.rules[element.getAttribute('name')] = rules;
				validator.settings.messages[element.getAttribute('name')] = messages;

				unobtrusive.adapters.forEach(function (adapter) {
					var prefix = 'data-val-' + adapter.name;
					var message = $element.attr(prefix);
					var paramValues = {};

					if (message !== undefined) {
						// Compare against undefined, because an empty message is legal (and falsy)
						prefix += '-';
						adapter.params.forEach(function (parameter) {
							paramValues[parameter] = $element.attr(prefix + parameter);
						});
						adapter.adapt({
							element: element,
							form: form,
							message: message,
							params: paramValues,
							rules: rules,
							messages: messages
						});
					}
				});
			}
		}

		if (window.pushpay && window.pushpay.features && window.pushpay.features.SanitizeJavascript) {
			addPanHandlingValidationRule();
			$('input[type="text"]:not([data-ignore-pan-like]), textarea:not([data-ignore-pan-like])')
				.each(function (index, element) {
					$(element).attr('data-val-panhandling',
						'For your security, please only enter your credit card details into credit card fields.');
					attachElementValidation(element);
				});
		}
	});
});
